import { Button } from "components/button";
import Card from "components/card";
import { useEffect, useState } from "react";
import { notificationsService } from "views/services/pushNotifcationService";
import { TBaseTokenData } from "views/types/token";

const PushNotificationsView = () => {
  const [title, setTitle] = useState("");
  const [message, setMessage] = useState("");
  const [tokenTitle, setTokenTitle] = useState("");
  const [tokenMessage, setTokenMessage] = useState("");
  const [tokenAddress, setTokenAddress] = useState("");
  const [setting, setSetting] = useState(false);
  const [error, setError] = useState("");
  const [tokenError, setTokenError] = useState("");
  const [mainUserId, setMainUserId] = useState<number>();
  const [tokenToSend, setTokenToSend] = useState<TBaseTokenData | null>(null);

  const normalizedTitle = title.trim();
  const normalizedMessage = message.trim();

  const normalizedTokenTitle = tokenTitle.trim();
  const normalizedTokenMessage = tokenMessage.trim();
  const normalizedTokenAddress = tokenAddress.trim();

  const isButtonDisabled =
    !normalizedTitle.length || !normalizedMessage.length || !!error;
  const isTokenButtonDisabled =
    !normalizedTokenTitle ||
    !normalizedTokenMessage ||
    !normalizedTokenAddress ||
    !!tokenError;

  useEffect(() => {
    const getUserId = async () => {
      const id = await notificationsService.getMainUserId();
      setMainUserId(id);
    };

    getUserId();
  }, []);

  const handleSend = async () => {
    try {
      setSetting(true);
      notificationsService.sendToAll({ title, message });
      setTitle("");
      setMessage("");
    } catch {
    } finally {
      setSetting(false);
    }
  };

  const getTokenInfo = async () => {
    try {
      setSetting(true);
      const token = await notificationsService.getTokenInfo(tokenAddress);
      setTokenToSend(token);
      return token;
    } catch (e) {
      setTokenToSend(null);
      throw e;
    } finally {
      setSetting(false);
    }
  };

  const handleSendToken = async () => {
    try {
      setSetting(true);
      if (!tokenToSend) {
        const token = await getTokenInfo();
        await notificationsService.sendToAll({
          title: tokenTitle,
          message: tokenMessage,
          token: token,
        });
      } else {
        await notificationsService.sendToAll({
          title: tokenTitle,
          message: tokenMessage,
          token: tokenToSend,
        });
      }
      setTokenTitle("");
      setTokenMessage("");
      setTokenToSend(null);
      setTokenAddress("");
    } catch (e) {
      console.log(e);
    } finally {
      setSetting(false);
    }
  };

  const handleSendTest = async () => {
    try {
      setSetting(true);
      if (!tokenToSend) {
        const token = await getTokenInfo();
        await notificationsService.sendTestToken({
          title: tokenTitle,
          message: tokenMessage,
          token: token,
          userId: mainUserId,
        });
      } else {
        await notificationsService.sendTestToken({
          title: tokenTitle,
          message: tokenMessage,
          token: tokenToSend,
          userId: mainUserId,
        });
      }
    } catch {
    } finally {
      setSetting(false);
    }
  };

  const handleInputTitle = (
    e: React.ChangeEvent<HTMLInputElement>,
    isToken = false
  ) => {
    const newTitle = e.target.value;
    if (newTitle.length > 31) {
      if (isToken) {
        setTokenTitle(newTitle);
        setTokenError("Title must be less than 30 characters");
      } else {
        setTitle(newTitle);
        setError("Title must be less than 30 characters");
      }
    } else {
      if (isToken) {
        setTokenTitle(newTitle);
        setTokenError("");
      } else {
        setTitle(newTitle);
        setError("");
      }
    }
  };
  const handleInputMessage = (
    e: React.ChangeEvent<HTMLTextAreaElement>,
    isToken = false
  ) => {
    const newMessage = e.target.value;
    if (newMessage.length > 50) {
      if (isToken) {
        setTokenMessage(newMessage);
        setTokenError("Message must be less than 50 characters");
      } else {
        setMessage(newMessage);
        setError("Message must be less than 50 characters");
      }
    } else {
      if (isToken) {
        setTokenMessage(newMessage);
        setTokenError("");
      } else {
        setMessage(newMessage);
        setError("");
      }
    }
  };

  const handleSetTokenAddress = (e: React.ChangeEvent<HTMLInputElement>) => {
    setTokenAddress(e.target.value);
    if (tokenToSend) {
      setTokenToSend(null);
    }
  };

  return (
    <Card
      extra={
        "w-full sm:h-[800px] min-h-[400px] md:h-[500px] sm:overflow-auto px-6 pb-4 mt-8"
      }
    >
      <div className="pt-10 flex flex-col items-start">
        <p className="font-medium">Regular push notification</p>
        <div className="flex gap-2 items-center pt-4 sm:flex-row sm:gap-5 w-full sm:pt-5">
          <input
            type="text"
            placeholder="Enter title"
            className="border rounded-md block min-h-7 bg-lightPrimary px-4 py-1 text-base font-medium text-navy-700 outline-none placeholder:!text-gray-400 sm:py-2 w-60 sm:h-full invalid:border-red-500"
            value={title}
            onChange={handleInputTitle}
          />
        </div>
        <div className="flex gap-2 items-center pt-4 sm:flex-row sm:gap-5 w-full sm:pt-5">
          <textarea
            placeholder="Enter message"
            className="border rounded-md block min-h-7 bg-lightPrimary px-4 py-1 text-base font-medium text-navy-700 outline-none placeholder:!text-gray-400 sm:py-2 w-60 sm:h-full invalid:border-red-500"
            value={message}
            onChange={handleInputMessage}
          />
          <Button
            disabled={isButtonDisabled}
            onClick={handleSend}
            className="border p-2 min-w-28 rounded-md border-gray-800 hover:text-black flex cursor-pointer items-center gap-2 text-gray-600 hover:font-medium"
          >
            {setting ? "Sending..." : "Send notification"}
          </Button>
        </div>
        <p className="text-red-500 font-medium mt-2">{error}</p>
      </div>
      <div className="pt-10 flex flex-col items-start">
        <p className="font-medium">Push Notifications with tokens</p>
        <div className="flex gap-2 items-center pt-4 sm:flex-row sm:gap-5 w-full sm:pt-5">
          <input
            type="text"
            placeholder="Enter title"
            className="border rounded-md block min-h-7 bg-lightPrimary px-4 py-1 text-base font-medium text-navy-700 outline-none placeholder:!text-gray-400 sm:py-2 w-60 sm:h-full invalid:border-red-500"
            value={tokenTitle}
            onChange={(e) => handleInputTitle(e, true)}
          />
        </div>
        <div className="flex gap-2 items-center pt-4 sm:flex-row sm:gap-5 w-full sm:pt-5">
          <input
            type="text"
            placeholder="Enter token address"
            className="border rounded-md block min-h-7 bg-lightPrimary px-4 py-1 text-base font-medium text-navy-700 outline-none placeholder:!text-gray-400 sm:py-2 w-60 sm:h-full invalid:border-red-500"
            value={tokenAddress}
            onChange={handleSetTokenAddress}
          />
        </div>
        <div className="flex flex-col items-start gap-2 sm:items-center pt-4 sm:flex-row sm:gap-5 w-full sm:pt-5">
          <textarea
            placeholder="Enter message"
            className="border rounded-md block min-h-7 bg-lightPrimary px-4 py-1 text-base font-medium text-navy-700 outline-none placeholder:!text-gray-400 sm:py-2 w-60 sm:h-full invalid:border-red-500"
            value={tokenMessage}
            onChange={(e) => handleInputMessage(e, true)}
          />
          <Button
            disabled={isTokenButtonDisabled}
            onClick={handleSendTest}
            className="border p-2 sm:min-w-28 rounded-md border-gray-800 hover:text-black flex cursor-pointer items-center gap-2 text-gray-600 hover:font-medium"
          >
            {setting ? "Sending..." : "Send test notification"}
          </Button>
          <Button
            disabled={isTokenButtonDisabled}
            onClick={handleSendToken}
            className="border p-2 sm:min-w-28 rounded-md border-gray-800 hover:text-black flex cursor-pointer items-center gap-2 text-gray-600 hover:font-medium"
          >
            {setting ? "Sending..." : "Send notification to all"}
          </Button>
        </div>

        <p className="text-red-500 font-medium mt-2">{tokenError}</p>
      </div>
    </Card>
  );
};

export default PushNotificationsView;
